import { FC } from 'react';
import { Box, Card, Typography, Chip } from '@mui/material';
import { Draggable } from 'react-beautiful-dnd';
import MemberAvatar from '../../../MemberAvatar';
import { ITaskUI } from '../../../../data/types/task.type';
import DueDate from './components/DueDate';
import TaskLabels from './components/TaskLabels';
import { useAppSelector } from '../../../../redux/store';

const TaskCard: FC<{
  task: ITaskUI;
  index: number;
  setOpenedTask: (taskId: string) => void;
}> = ({ task, index, setOpenedTask }) => {
  const filters = useAppSelector(state => state.boardFilterSlice)[
    task.boardId
  ] || {
    assignees: [],
    labels: [],
  };
  const show =
    (!filters.labels.length ||
      task.labels.some(label => filters.labels.includes(label))) &&
    (!filters.assignees.length ||
      filters.assignees.includes(task.assignee?.userId || ''));
  const openModal = () => {
    setOpenedTask(task.taskId);
  };

  return (
    <>
      {show && (
        <Draggable draggableId={task.taskId} index={index}>
          {(provided, snapshot) => (
            <Card
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              ref={provided.innerRef}
              sx={{
                width: 1,
                p: 2,
                mb: 1.5,
                borderRadius: 2.5,
                cursor: 'pointer',
                backgroundColor: 'background.paper',
                border: '1px solid',
                borderColor: snapshot.isDragging ? 'primary.light' : 'transparent',
                boxShadow: snapshot.isDragging
                  ? '0 8px 24px rgba(0, 0, 0, 0.15)'
                  : '0 1px 3px rgba(0, 0, 0, 0.08)',
                transition: 'all 0.15s ease-in-out',
                '&:hover': {
                  borderColor: 'divider',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                },
              }}
              onClick={openModal}
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="flex-start"
                gap={1}
              >
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: '0.875rem',
                    lineHeight: 1.4,
                    color: 'text.primary',
                    overflowWrap: 'anywhere',
                    flex: 1,
                  }}
                >
                  {task.title}
                </Typography>
                {task.assignee && (
                  <MemberAvatar
                    {...task.assignee}
                    hideBadge
                    avatarSize={28}
                    avatarSx={{
                      fontSize: '0.75rem',
                      fontWeight: 500,
                      flexShrink: 0,
                    }}
                  />
                )}
              </Box>

              {(task.dueDate || task.labels.length > 0) && (
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="flex-start"
                  gap={1}
                  mt={1.5}
                  flexWrap="wrap"
                >
                  <DueDate dueDate={task.dueDate} />
                  <TaskLabels labels={task.labels} projectId={task.projectId} />
                </Box>
              )}
            </Card>
          )}
        </Draggable>
      )}
    </>
  );
};

export default TaskCard;
